import { getUserSetting } from '../../../common/ambient'
import { pipe, pluck, filter, nth, find, propEq, contains } from 'ramda'
import { setDashboardDevice } from './setDashboardDevice'

export function ensureDashboardDevice () {
  return (dispatch, getState) => {
    const state = getState()
    const { device, user, social } = state
    const { dashboardDevice, devices, getDeviceFailures = [] } = device
    const { favs } = social || {}

    // Already set, nothing to do
    if (dashboardDevice) {
      return Promise.resolve(dashboardDevice)
    }

    // Wait for user data to be loaded before selecting a device
    if (!user.userChecked) {
      return Promise.resolve(null)
    }

    let selectedDevice = null

    // 1. Try user's most recent device
    const recent = getUserSetting('recent')(user)
    if (recent && recent[0]) {
      // If this is their device, use current state; otherwise use recent
      const myDevice = devices && find(propEq('macAddress', recent[0].macAddress), devices)
      selectedDevice = myDevice || recent[0]
    }

    // 2. Try first favorite
    if (!selectedDevice && favs) {
      selectedDevice = pipe(
        pluck('to'),
        filter(d => !contains(d._id, getDeviceFailures)),
        nth(0)
      )(favs)
    }

    // 3. Fall back to first owned device
    if (!selectedDevice && devices && devices[0]) {
      selectedDevice = devices[0]
    }

    if (selectedDevice) {
      dispatch(setDashboardDevice(selectedDevice))
      return Promise.resolve(selectedDevice)
    }

    return Promise.resolve(null)
  }
}
